import React from 'react';
import { useAppDispatch } from 'hooks';

import { toggleOption } from '~weekly-planner/reducers/weeklyPlanner';

import { CommonOptions } from './CommonOptions';

interface ComponentProps {
  totalSimple: boolean;
  totalAppointments: boolean;
  totalPredicted: boolean;
  totalDistance: boolean;
}

export const TotalOptions: React.FC<ComponentProps> = ({
  totalSimple,
  totalAppointments,
  totalPredicted,
  totalDistance,
}) => {
  const dispatch = useAppDispatch();

  const options = [
    {
      id: 'simple',
      label: 'Simple',
      tooltip: 'Show basic hour totals in a simplified format',
      checked: totalSimple,
      onChange: () => dispatch(toggleOption({ key: 'totalSimple', toggle: !totalSimple })),
    },
    {
      id: 'appointments',
      label: 'Appointments',
      tooltip: 'Display total number of appointments in the view',
      checked: totalAppointments,
      onChange: () => dispatch(toggleOption({ key: 'totalAppointments', toggle: !totalAppointments })),
    },
    {
      id: 'predictedShift',
      label: 'Predicted Shift',
      tooltip: 'Show predicted total shift durations for workers',
      checked: totalPredicted,
      onChange: () => dispatch(toggleOption({ key: 'totalPredicted', toggle: !totalPredicted })),
    },
    {
      id: 'distance',
      label: 'Distance',
      tooltip: 'Display total travel distance for routes',
      checked: totalDistance,
      onChange: () => dispatch(toggleOption({ key: 'totalDistance', toggle: !totalDistance })),
    },
  ];

  return <CommonOptions title="Select which summary metrics to display" options={options} />;
};
